import { lighten, Theme } from "@mui/material";

const useStyles = (theme: Theme) => ({
  textAdorment: {
    mt: "2.5px",
    ml: "-5px",
    fontSize: "13px",
    fontWeight: 800,
    color: theme.palette.text.disabled,
  },
  titleTextField: {
    fontSize: "16px",
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
  title: {
    fontSize: { xs: "20px", md: "28px" },
    fontWeight: 500,
    width: "fit-content",
  },
  subTitle: {
    fontSize: { xs: "14px", md: "16px" },
    width: "fit-content",
    color: theme.palette.text.secondary,
  },
  linkSpan: {
    color: theme.palette.primary.main,
    marginLeft: "5px",
    marginTop: "-2px",
    "&:hover": {
      color: lighten(theme.palette.primary.main, 0.2),
    },
  },
  link: {
    color: theme.palette.text.primary,
    textDecoration: "none",
    fontSize: { xs: "14px", md: "16px" },
  },
  container: {
    fontFamily: "Roboto",
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
  },
  paperLeft: (background: string) => ({
    backgroundImage: `url(${background})`,
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    backgroundRepeat: "no-repeat",
    borderRadius: "0px!important",

    height: "100vh",
    minWidth: "300px",
    minHeight: "500px",
    display: { xs: "none", md: "flex" },
    width: { xs: "0vw", md: "50vw", mdl: "60vw" },
    justifyContent: "center",
    alignContent: "center",
  }),
  paperRight: {
    minHeight: "500px",
    minWidth: "310px",
    borderRadius: "0px!important",
    padding: { xs: "50px", md: "100px" },
    width: { xs: "100vw", md: "50vw", mdl: "40vw" },
    height: "100vh",
    alignItems: "start",
    justifyContent: "start",
    flexDirection: "column",
    display: "flex",
    gap: { xs: "30px", md: "100px" },
  },

  formBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "start",
    width: "100%",
    gap: "22px",
  },
  formControl: {
    m: 1,
    width: "90%",
    marginTop: "10px",
  },

  footerPaper: {
    bottom: "0px",
    position: "absolute",
    width: { xs: "100vw", md: "40vw" },
    textAlign: "center",
    padding: "0px 20px",
  },
  footerText: {
    fontSize: "0.8em",
  },
  logo: {
    fill: theme.palette.text.primary,
    height: "auto",
    width: "120px",
  },
});

export default useStyles;
